import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { HomeCloseWelcomeChannel } from '../../app/actions/AppActionTypes';
import { ServiceLocator } from '../../app/ServiceLocator';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { Messages } from '../../codegen/Localize';
import { showActionableToast } from '../../common/react/components/ActionableMessage';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { GetServerWelcomeChannelInfoRequest, GetServerWelcomeChannelInfoResult } from '../../ts/ServerApi/requests/GetServerWelcomeChannelInfoRequest';
import { SetShowWelcomeScreenRequest } from '../../ts/ServerApi/requests/SetShowWelcomeScreenRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { getSessionManagementServiceInstance, SessionManagementService } from '../../sessionManagement/SessionManagementService';
import { ToastType } from '../../ts/services/ToasterService';
import { getServerWelcomeChannelInfoSucceededAction } from '../actions/HomeActions';
import WebHttpClient from '../../httpClient/WebHttpClient';

export function* homeCloseWelcomeChannel() {
  try {
    yield call(sendCloseWelcomeScreenRequest);
    yield call(showDismissedWelcomeChannelToast);
  }
  catch(e) {
    // TODO: Fire off a failure log, we don't want to display a toast to the user in this case.
    yield call(logHomeFailure);
  }
}

// This could be refactored to sendShowWelcomeScreenRequest(boolean) to allow showing/hiding in the future
export function sendCloseWelcomeScreenRequest(): Promise<IResult> {
  return WebHttpClient.sendRequest(new SetShowWelcomeScreenRequest({ showWelcomeScreen: false }));
}

export function showDismissedWelcomeChannelToast() {
  showActionableToast({
    testId: 'dismissed-welcome-channel-success',
    message: Messages.home_welcomeChannel_dismissed_toast(),
    actionMessage: Messages.changeSettings(),
    action: linkToMyAccountSettings
  }, ToastType.Success);
}

function linkToMyAccountSettings(): void {
  const serverService = getSessionManagementServiceInstance();
  const siteUrls = new SpacesSiteUrls({
    siteUrlName: serverService.sessionSiteUrlName(),
  });
  const link = siteUrls.userSettingsUrl(serverService.sessionUsername(), serverService.sessionUserDomainName());
  const locationService = ServiceLocator.get<ng.ILocationService>('$location');
  locationService.url(link.slice(2)); // Remove /# from the front of the link
  ServiceLocator.getAngularActionContext().scope.$apply();
}

export function* fetchServerWelcomeChannelInfo() {
  if (FeatureFlags.serverWelcomeChannelEnabled) {
    const result = yield call(sendGetServerWelcomeChannelInfoRequest);
    yield put(getServerWelcomeChannelInfoSucceededAction(result));
  }
}

export function sendGetServerWelcomeChannelInfoRequest(): Promise <GetServerWelcomeChannelInfoResult> {
  return WebHttpClient.sendRequest(new GetServerWelcomeChannelInfoRequest());
}

export function logHomeFailure() {
  // TODO: Will be implemented when we figure out how we want to do monitoring.
}

export function* rootHomeSaga(): SagaIterator {
  yield takeEvery(HomeCloseWelcomeChannel, homeCloseWelcomeChannel);
}
